var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['v-navbar', _vm.alerts && 'v-navbar--alerts'],style:([
    _vm.hidden && { transform: `translateY(-${this.hiddenHeight()}px)` },
    !_vm.hidden &&
      _vm.hiddenAlerts && { transform: `translateY(-${this.alertsHeight}px)` }
  ])},[(_vm.alerts)?_c('div',{class:[
      'v-navbar__alerts',
      { 'v-navbar__alerts--expanded': !_vm.collapsed }
    ]},[_vm._t("alerts")],2):_vm._e(),_c('div',{staticClass:"v-navbar__content container-fluid"},[_c('div',{staticClass:"row justify-content-between align-items-center h-100"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }